module.exports = __webpack_public_path__ + "static/media/dollar-sign.2fe03328.svg";